// src/pages/TermsOfService.jsx
import React from 'react';
import '../assets/css/global.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-page">
      <section className="py-5 about_pg">
        <br/><br/><br/><br/>
        <div className="container-xl">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-center mb-4 col_red">Terms of Service</h1>
              <p className="text-center col_light mb-5">
                <strong>Effective Date:</strong> October 20, 2025
              </p>

              <div className="content-section">
                <h3 className="col_red">1. Agreement to Terms</h3>
                <p className="col_light">
                  Welcome to Spono! These Terms of Service ("Terms") constitute a legally binding agreement between you and Spono ("we," "our," or "us") regarding your use of the Spono mobile application and web platform (collectively, the "Service").
                </p>
                <p className="col_light">
                  By accessing or using our Service, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, please do not use our Service.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">2. Description of Service</h3>
                <p className="col_light">
                  Spono is a platform that connects event attendees with personalized event experiences. Our Service allows you to:
                </p>
                <ul className="col_light">
                  <li>Discover and browse events</li>
                  <li>Check in to events using QR codes</li>
                  <li>Capture and share photos and videos from events</li>
                  <li>Receive personalized event moments and footage</li>
                  <li>Connect with other event attendees</li>
                  <li>Manage your event history and profile</li>
                </ul>
              </div>

              <div className="content-section">
                <h3 className="col_red">3. Eligibility</h3>
                <p className="col_light">
                  You must be at least 13 years old to use our Service. By using Spono, you represent and warrant that you meet this age requirement. If you are under 18, you must have permission from a parent or legal guardian to use our Service.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">4. User Accounts</h3>
                
                <h5 className="col_red mt-4">4.1 Account Creation</h5>
                <p className="col_light">
                  To use certain features of the Service, you must create an account. You agree to:
                </p>
                <ul className="col_light">
                  <li>Provide accurate, current, and complete information</li>
                  <li>Maintain and update your information to keep it accurate</li>
                  <li>Maintain the security of your password and account</li>
                  <li>Accept responsibility for all activities under your account</li>
                  <li>Notify us immediately of any unauthorized use of your account</li>
                </ul>

                <h5 className="col_red mt-4">4.2 Account Types</h5>
                <p className="col_light">
                  We offer two types of accounts:
                </p>
                <ul className="col_light">
                  <li><strong>Regular Users:</strong> Individuals who attend events and use the app to capture and receive moments</li>
                  <li><strong>Event Promoters:</strong> Organizations or individuals who organize events and manage event check-ins and content</li>
                </ul>
              </div>

              <div className="content-section">
                <h3 className="col_red">5. User Conduct</h3>
                
                <h5 className="col_red mt-4">5.1 Acceptable Use</h5>
                <p className="col_light">You agree to use our Service only for lawful purposes and in accordance with these Terms. You agree NOT to:</p>
                <ul className="col_light">
                  <li>Violate any applicable laws or regulations</li>
                  <li>Infringe on the intellectual property rights of others</li>
                  <li>Upload or share content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, or otherwise objectionable</li>
                  <li>Impersonate any person or entity or misrepresent your affiliation with a person or entity</li>
                  <li>Interfere with or disrupt the Service or servers or networks connected to the Service</li>
                  <li>Attempt to gain unauthorized access to any portion of the Service</li>
                  <li>Use automated systems (bots, scrapers, etc.) to access the Service</li>
                  <li>Harass, abuse, or harm other users</li>
                  <li>Upload viruses or malicious code</li>
                  <li>Collect or store personal data of other users without permission</li>
                </ul>

                <h5 className="col_red mt-4">5.2 Content Standards</h5>
                <p className="col_light">
                  All content you upload or share through Spono must comply with applicable laws and must not contain material that is illegal, offensive, or violates the rights of others.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">6. User Content</h3>
                
                <h5 className="col_red mt-4">6.1 Content Ownership</h5>
                <p className="col_light">
                  You retain all ownership rights to the content you upload to Spono (photos, videos, profile information, etc.). However, by uploading content, you grant Spono a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, and distribute your content for the purpose of providing and improving our Service.
                </p>

                <h5 className="col_red mt-4">6.2 Content Responsibility</h5>
                <p className="col_light">
                  You are solely responsible for the content you upload and share through our Service. We do not endorse or assume any liability for user content. We reserve the right to remove any content that violates these Terms or is otherwise objectionable.
                </p>

                <h5 className="col_red mt-4">6.3 Content Moderation</h5>
                <p className="col_light">
                  While we do not pre-screen user content, we reserve the right to monitor, review, and remove content that violates these Terms or applicable laws. We may also suspend or terminate accounts that repeatedly violate these Terms.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">7. Event Check-Ins and QR Codes</h3>
                <p className="col_light">
                  Our Service uses QR code technology for event check-ins. By checking in to an event:
                </p>
                <ul className="col_light">
                  <li>You confirm your attendance at the event</li>
                  <li>You agree to share your profile information with the event organizer</li>
                  <li>You consent to receiving event-related content and notifications</li>
                  <li>You authorize Spono to capture and share event footage with you</li>
                </ul>
                <p className="col_light">
                  Event organizers are responsible for obtaining necessary permissions and rights to capture content at their events.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">8. Intellectual Property</h3>
                
                <h5 className="col_red mt-4">8.1 Spono's Intellectual Property</h5>
                <p className="col_light">
                  The Service, including its original content, features, functionality, design, logos, and branding, is owned by Spono and is protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                </p>

                <h5 className="col_red mt-4">8.2 Restrictions</h5>
                <p className="col_light">
                  You may not copy, modify, distribute, sell, or lease any part of our Service without our prior written permission. You may not reverse engineer or attempt to extract the source code of our software.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">9. Privacy and Data Protection</h3>
                <p className="col_light">
                  Your privacy is important to us. Our collection and use of personal information is described in our Privacy Policy. By using our Service, you consent to our collection and use of information as described in the Privacy Policy.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">10. Third-Party Services</h3>
                <p className="col_light">
                  Our Service may contain links to third-party websites or services that are not owned or controlled by Spono. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party services. You acknowledge and agree that Spono shall not be liable for any damage or loss caused by your use of any third-party services.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">11. Disclaimers and Limitations of Liability</h3>
                
                <h5 className="col_red mt-4">11.1 Service "As Is"</h5>
                <p className="col_light">
                  Our Service is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, either express or implied. We do not warrant that:
                </p>
                <ul className="col_light">
                  <li>The Service will be uninterrupted, secure, or error-free</li>
                  <li>The results obtained from using the Service will be accurate or reliable</li>
                  <li>Any errors in the Service will be corrected</li>
                  <li>The Service will meet your specific requirements</li>
                </ul>

                <h5 className="col_red mt-4">11.2 Limitation of Liability</h5>
                <p className="col_light">
                  To the maximum extent permitted by law, Spono shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from:
                </p>
                <ul className="col_light">
                  <li>Your use or inability to use the Service</li>
                  <li>Any unauthorized access to or use of our servers and/or any personal information stored therein</li>
                  <li>Any interruption or cessation of transmission to or from the Service</li>
                  <li>Any bugs, viruses, or malicious code that may be transmitted through the Service</li>
                  <li>Any errors or omissions in any content or for any loss or damage incurred as a result of your use of any content</li>
                </ul>
              </div>

              <div className="content-section">
                <h3 className="col_red">12. Indemnification</h3>
                <p className="col_light">
                  You agree to defend, indemnify, and hold harmless Spono and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with:
                </p>
                <ul className="col_light">
                  <li>Your access to or use of the Service</li>
                  <li>Your violation of these Terms</li>
                  <li>Your violation of any third-party right, including any intellectual property, privacy, or publicity right</li>
                  <li>Any content you upload or share through the Service</li>
                </ul>
              </div>

              <div className="content-section">
                <h3 className="col_red">13. Termination</h3>
                <p className="col_light">
                  We may terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason, including if you breach these Terms. Upon termination, your right to use the Service will immediately cease.
                </p>
                <p className="col_light">
                  You may delete your account at any time through the app settings or by contacting us at support@spono.ai. Upon account deletion, we will delete your personal information in accordance with our Privacy Policy and data retention policies.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">14. Changes to Terms</h3>
                <p className="col_light">
                  We reserve the right to modify or replace these Terms at any time at our sole discretion. We will provide notice of any material changes by posting the new Terms on this page and updating the "Effective Date" above. Your continued use of the Service after any changes constitutes acceptance of the new Terms.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">15. Governing Law and Dispute Resolution</h3>
                <p className="col_light">
                  These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions. Any disputes arising from these Terms or your use of the Service shall be resolved through binding arbitration in accordance with the rules of [Arbitration Association], except where prohibited by law.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">16. Severability</h3>
                <p className="col_light">
                  If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will continue in full force and effect. The invalid or unenforceable provision will be deemed modified to the extent necessary to make it valid and enforceable.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">17. Entire Agreement</h3>
                <p className="col_light">
                  These Terms, together with our Privacy Policy, constitute the entire agreement between you and Spono regarding your use of the Service and supersede all prior agreements and understandings.
                </p>
              </div>

              <div className="content-section">
                <h3 className="col_red">18. Contact Information</h3>
                <p className="col_light">
                  If you have any questions about these Terms, please contact us at:
                </p>
                <ul className="col_light">
                  <li><strong>Email:</strong> legal@spono.ai</li>
                  <li><strong>Support:</strong> support@spono.ai</li>
                  <li><strong>Website:</strong> https://spono.ai</li>
                </ul>
              </div>

              <div className="text-center mt-5 mb-5">
                <p className="col_light">
                  <strong>By using Spono, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <br/><br/>
      </section>
    </div>
  );
};

export default TermsOfService;
